import { DestroyRef, Directive, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent, tap } from 'rxjs';
import { FixedHeightService } from '../services';

@Directive()
export class FixedHeightDesktopDirective implements OnInit, OnDestroy {
    private readonly fixedHeightService = inject(FixedHeightService);
    private readonly destroyRef = inject(DestroyRef);

    ngOnInit() {
        const mediaQuery = window.matchMedia('(min-width: 1024px)');
        this.fixedHeightService.setFixedHeight(mediaQuery.matches);

        fromEvent<MediaQueryListEvent>(mediaQuery, 'change')
            .pipe(
                tap((event) => this.fixedHeightService.setFixedHeight(event.matches)),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe();
    }

    ngOnDestroy() {
        this.fixedHeightService.setFixedHeight(false);
    }
}
